import { render, staticRenderFns } from "./TabelaPendentes.vue?vue&type=template&id=654bfad0&scoped=true&"
import script from "./TabelaPendentes.vue?vue&type=script&lang=js&"
export * from "./TabelaPendentes.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPendentes.vue?vue&type=style&index=0&id=654bfad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bfad0",
  null
  
)

export default component.exports